import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

const ROLE_LABELS = {
  tr: {
    "Anne": "Anne", "Baba": "Baba", "Çocuk": "Çocuk", "Amca": "Amca", "Teyze": "Teyze", "Nene": "Nene", "Dede": "Dede", "Dayı": "Dayı",
    "Aile Yöneticisi": "Aile Yöneticisi", "Aile Üyesi": "Aile Üyesi", "Üye": "Üye",
  },
  en: {
    "Anne": "Mother", "Baba": "Father", "Çocuk": "Child", "Amca": "Uncle", "Teyze": "Aunt", "Nene": "Grandmother", "Dede": "Grandfather", "Dayı": "Uncle",
    "Aile Yöneticisi": "Family Admin", "Aile Üyesi": "Family Member", "Üye": "Member",
  },
};

const roleLabel = (role, lang = "tr") => ROLE_LABELS[lang]?.[role] || role || "";

function Header({ familyName, profil, cikisYap, menuAc, noMenu, geriDon, rightAction }) {
  const { lang } = useLanguage();
  return (
    <div className="topHeader">
      {/* Sol: Geri butonu */}
      <div className="headerLeft">
        {geriDon && (
          <button onClick={geriDon} className="headerIconBtn">
            ‹
          </button>
        )}
      </div>

      {/* Orta: Başlık */}
      <div className="headerCenter">
        <h1 className="mainFamilyTitle">{familyName}</h1>
        {profil && (
          <p className="welcomeUser">
            {profil.ad} {profil.soyad} · {roleLabel(profil.aileYetkisi || profil.rol, lang)}
          </p>
        )}
      </div>

      {/* Sağ: Menü */}
      <div className="headerRight">
        {rightAction ? (
          <button type="button" className={rightAction.className || "menuButton"} onClick={rightAction.onClick} aria-label={rightAction.label} title={rightAction.label}>
            {rightAction.icon}
          </button>
        ) : !noMenu && (
          <button className="menuButton" onClick={menuAc}>
            ☰
          </button>
        )}
      </div>
    </div>
  );
}

export default Header;
